export default __webpack_public_path__ + "static/media/preview-shareable-status-link.f9ccdac2.svg";